var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center justify-center h-full cursor-pointer",on:{"click":function($event){$event.stopPropagation();return _vm.toggle.apply(null, arguments)}}},[_c('checkbox',{attrs:{"table":"","value":_vm.selected}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }